/**
 * Query-key prefixes for every repository.
 *
 * This module must stay a leaf — it may not import anything, and in particular not a repository or
 * `services/http/queryClient`. The keys used to live in the repositories that own them, which put
 * `queryClient` (it needs the whole set to build its global-invalidation list) downstream of ten
 * repositories that each import `queryClient` back, so any new `queryClient` consumer among them
 * closed a `queryClient -> repository -> queryClient` cycle.
 */
export const BILLING_QUERY_KEY = '/billing';
export const CONNECTIONS_QUERY_KEY = '/connections';
export const INBOX_QUERY_KEY = '/inbox';
export const INVOICE_VERIFICATION_QUERY_KEY = '/invoice-verification';
export const MESSAGES_QUERY_KEY = '/messages';
export const NOTIFICATIONS_MANAGEMENT_QUERY_KEY = '/partners/current/responsible';
export const PARTNERS_QUERY_KEY = '/partners';
export const PAYMENT_RECONCILIATION_QUERY_KEY = 'payment-reconciliation';
export const PAYMENT_RECONCILIATION_DETAIL_QUERY_KEY = `${PAYMENT_RECONCILIATION_QUERY_KEY}/detail`;
export const PRICING_CONFIGS_QUERY_KEY = '/pricingConfigs';
export const RELATIONSHIPS_QUERY_KEY = '/relationships';
export const STATS_QUERY_KEY = '/stats';
export const TASKS_QUERY_KEY = 'tasks';
export const TRANSACTIONS_QUERY_KEY = '/transactions';
